import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

export default (props) => {
  let style = {
    verticalAlign: "middle",
    ...props.style,
  };
  return (
    <LoadingSpinner marginX="10px" width="25px" height="25px" style={style} />
  );
};
